<template>
  <section class="therapist">
    <div class="container">

      <div class="left">
        <h2>Jeg heter Roy Arve Smørholm, og i dag lever jeg et liv i balanse – men det har ikke alltid vært slik.</h2>
        <p>
          I over 25 år jobbet jeg i lederstillinger i næringslivet, alltid med et ønske om å levere best, yte maksimalt og bevise at jeg var god nok. Jeg satte alltid andre først, og skjøv mine egne behov til side. Resultatet? En kollaps. For tre år siden møtte jeg veggen – utbrent, følelsesmessig tappet, og fanget i et liv som ikke lenger var meg.<br><br>
          Dette ble starten på en total endring. <br><br>
          I dag jobber jeg som hypnoterapeut, EFT-utøver (emotional freedom techniques) og medmenneske – med et sterkt ønske om å hjelpe andre som står i sine egne livsutfordringer. Jeg vet hvordan det føles å være fanget i stress, prestasjon og selvutslettelse. Jeg vet hvordan det er å miste seg selv – og hvordan det føles å finne seg selv igjen.<br><br>
          Hypnose og selvhypnose ble avgjørende i min egen helingsprosess. Jeg har brukt det aktivt på meg selv, og det har hjulpet meg til dyp selvinnsikt, ro og varige endringer. I tillegg mediterer jeg daglig, og henter styrke i naturen – gjerne med fiskestang i hånden og stillheten som selskap. <br><br>
          Mine klienter beskriver meg som trygg, lyttende og tilstede. Du kan forvente en varm og profesjonell tilnærming – helt fri for dømming, og full av forståelse.<br><br>
          Jeg tilbyr behandlinger og veiledning som vist på siden her, og i tillegg har jeg med jevne mellomrom kurs i selvhypnose.
          <br><br>
          Mitt motto er enkelt:<br>
          Alt kan behandles.<br>
          Jeg tror på deg – og jeg er her for å støtte deg på din vei.
        </p>
      </div>

      <div class="right">
        <img src="@/assets/images/roy.jpg" alt="Roy" />
      </div>
    </div>
    
    <div class="container">

      <div class="left">
        <h2>Maya Aursnes</h2>

        <p><strong>Samtalepartner – Medmenneske – Coach</strong></p>

        <p>
          Jeg har vært gjennom både tøffe og verdifulle livserfaringer, og har utviklet en dyp forståelse 
          for hva det vil si å stå i utfordringer – og kommet styrket ut på den andre siden. 
          Det har gitt meg en trygg og innsiktsfull tilnærming som samtalepartner og coach.
        </p>

        <p>
          Med et ekte engasjement for mennesker, et varmt hjerte og et lyttende blikk, 
          møter jeg deg der du er – og støtter deg videre derfra. Mitt ønske er enkelt:
          Å hjelpe deg med å finne styrken, troen på deg selv og veien videre i ditt eget liv.
        </p>

        <p>
          <i>Jeg kan delta sammen med Roy i noen av hans behandlinger, om du skulle ønske det.</i>
        </p>

        <p>
          Vi kan sammen og hver for oss hjelpe deg med å finne veien videre i ditt liv.
          Les mer om mulighetene <router-link to="/treatments">her</router-link>.
        </p>

      </div>

      <div class="right">
        <img src="@/assets/images/maya.jpg" alt="Maya" />
      </div>
    </div>

    <div class="container">
      <div class="book-session">
        <h1>Vi kan hjelpe deg.</h1>

        <a href="/booking" class="header-button" >Book en gratis samtale</a>
  
        <p class="note">NB: Jeg går igjennom bookinger, og sender en e-post som bekrefter din time.</p>

        <br>

      </div>

    </div>

  </section>
</template>

<script>
export default {
  data() {
    return {

    };
  },
}
</script>

<style lang="scss">

.therapist {
  background: linear-gradient(300deg, rgba(232, 232, 230, 1) 0%, rgba(216, 213, 207, 1) 50%);
  // padding: 50px;
  
  .container {
    display: flex;
    flex-direction: row;

    @media (max-width: 900px) {
      flex-direction: column;

      .left {
        width: 100% !important;
        order: 2; // Move left section below right on mobile
      }

      .right {
        width: 100% !important;
        padding: 5px !important;
        order: 1; // Move right section above left on mobile

        img {
          width: 300px !important;
        }
      }
    }

    .left {
      display: flex;
      width: 50%;
      flex-direction: column;

      h2 {
        font-size: 2rem;
        margin-bottom: 20px;
        font-weight: bold;
        // color: black;
      }
  
      p {
        font-size: 1.2rem;
        line-height: 1.6;
        color: #333;
        margin-bottom: 30px;
      }
  
      .calendly-inline-widget {
        width: 100%;
        height: 700px;
        margin-bottom: 20px;
      }
  
      .note {
        font-size: 0.9rem;
        color: #666;
      }
    }

    .right {
      display: flex;
      width: 50%;
      flex-direction: column;
      color: black;
      padding: 20px;

      img {
        width: 100%;
        // max-width: 350px;
        height: auto;
        border-radius: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

    }

    .book-session {
      width: 100%;
      padding: 20px;
      // background: rgba(255, 255, 255, 0.8);
      border-radius: 10px;
      // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
      text-align: center;

      h1 {
        font-size: 2rem;
        margin-bottom: 30px;
        font-weight: bold;
        color: black;
      }

      p {
        font-size: 1rem;
        margin-top: 30px;
        color: black;

      }

      a {
        display: inline-block;
        padding: 20px 35px;
        font-size: 1.2rem;
        background: $green;
        color: white;
        text-decoration: none;
        border-radius: 5px;
        transition: background-color 0.3s;

        &:hover {
          background-color: lighten($green, 10%);
          color: $text-light;
        }
      }
    }

  }
}

</style>